import { useAuth } from "@/context/AuthContext";

/**
 * LO QUE SE VE CUANDO EL SERVIDOR DICE «VAS DEMASIADO RÁPIDO», que no es ni la pantalla de
 * acceso ni la de reconexión.
 *
 * DE DÓNDE SALE. Del 6 de octubre de 2026: el log del backend repetía el mismo ciclo de siete
 * peticiones, todas 429, y por delante salía la pantalla de reconexión —«estamos recuperando la
 * conexión con el servidor»—, que es falsa dos veces. El servidor no se había caído: estaba
 * contestando, y además contestando una cosa muy concreta. Y esa pantalla reintenta sola, así
 * que echaba leña justo al fuego que había.
 *
 * Las tres cosas que tiene que decir esta pantalla, y ninguna más:
 *   · que **no has salido** y no se ha roto nada;
 *   · que lo que pasa es que se han pedido demasiadas cosas seguidas;
 *   · y **cuánto hay que esperar**, que lo dice el propio servidor en `Retry-After`.
 *
 * Y NO REINTENTA SOLA, a propósito. Quien está delante pulsa cuando quiera; un reintento
 * automático contra un freno es lo que convirtió un minuto de espera en un bucle sin salida.
 */
export default function SesionFrenada() {
  const { reintenta, segundos } = useAuth();
  return (
    <div className="min-h-[calc(100vh-4rem)] dvh:min-h-[calc(100svh-4rem)] bg-white flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <div className="font-mono-alpha text-[10px] uppercase tracking-[0.22em] text-alpha-red">
          Vas demasiado rápido
        </div>
        <h1 className="mt-2 text-2xl text-alpha-black">Hay que esperar un momento</h1>
        <p className="mt-3 text-sm text-alpha-black/60">
          Se han pedido demasiadas cosas seguidas y el servidor ha puesto el freno.{" "}
          <strong className="text-alpha-black">No has salido</strong> y no se ha roto nada: tu
          sesión sigue donde estaba.
          {segundos > 0
            ? ` Vuelve a intentarlo dentro de ${segundos} segundo${segundos === 1 ? "" : "s"}.`
            : " Espera unos segundos y vuelve a intentarlo."}
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button type="button" onClick={reintenta}
            className="px-5 py-2 rounded-full bg-alpha-red text-white text-sm hover:brightness-110 transition">
            Volver a intentarlo
          </button>
        </div>
      </div>
    </div>
  );
}
